import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import CompareTable from '@/features/product/product-comparison-table/components/CompareTable.js';
import TabularData from '@/features/product/product-comparison-table/services/TabularData.js';
import { EditableComponent, MapTo } from '@adobe/aem-react-editable-components';
import * as _ from 'lodash-es';
import initSecContext from '../ProductPricing/data/initSecContext.js';
import ppUtilities from '../ProductPricing/ppUtilities';
import LocalContext from '../ProductPricing/data/Localization.js';
import {AEM_MAPPED_TYPES} from '@/constants.js';

class ProductPricingComparisonTableImpl extends Component {
	constructor(props) {
		super(props);
		this.dynamicTableRoot = document.querySelector('.ppc-table-wrapper');

		this.dialogInfo = this.props.fromDialog;
		this.setLocalizationText();
		this.initSecContext = initSecContext.getPropsContext();
		this.ctID = this.initSecContext.ctID;
		this.state = {
			tabularData: 'no_data_back',
			error: null,
		};
		this.tableUpdate = {};
		this.tableUpdateCallback = this.tableUpdateCallback.bind(this);
		initSecContext.setPretTableCallBack(this.tableUpdateCallback);
		this.comparisonTriggered = this.comparisonTriggered.bind(this);
		initSecContext.setComparsionUpdate(this.comparisonTriggered);
		this.handleComparisonSelection = this.handleComparisonSelection.bind(this);
		this.handleCancelComparions = this.handleCancelComparions.bind(this);
	}

	initDataCalls() {
		let endPointPromise = new Promise((resolve, reject) => {
			TabularData.normalized(this.tableUpdate.lookUpByProductPath, this.dialogInfo.pp_comparison_path, resolve, reject);
		});

		endPointPromise.then((tabularData) => {
			this.updateComparableProducts(tabularData.products);
			// set comparable prod to app context
			initSecContext.setComparableProducts(tabularData.products);
			this.setState({
				tabularData,
				compTableActive: this.tableUpdate.compTableActive,
				comparableProducts: this.tableUpdate.comparableProducts,
			});
		});
	}

	updateComparableProducts(products) {
		// remove products not on the csv file
		let comparableProducts = [];
		this.tableUpdate.comparableProducts.forEach((prod) => {
			products.forEach((compProd) => {
				if (compProd.id == prod.id) {
					comparableProducts.push(prod);
				}
			});
		});
		this.tableUpdate.comparableProducts = comparableProducts;
	}

	setLocalizationText() {
		let labels = {
			compareBtn: this.dialogInfo.compareBtn,
			compareProductHeading: this.dialogInfo.compareProductHeading,
			compareProductsHeading: this.dialogInfo.compareProductsHeading,
			cancelButton: this.dialogInfo.cancelButton,
			selectProdToCompare: this.dialogInfo.selectProdToCompare,
			selectItemsToHeading: this.dialogInfo.selectItemsToHeading,
		};
		LocalContext.setTableLabels(labels);
	}

	handleComparisonSelection(activeCardId) {
		initSecContext.ribbonActiveComparison(activeCardId);
	}

	tableUpdateCallback(tableUpdate) {
		this.tableUpdate = tableUpdate;
		this.initDataCalls();
	}

	handleCancelComparions() {
		initSecContext.handleCancelComparions();
	}

	comparisonTriggered({ compTableActive, comparableProducts }) {
		let currState = this.state.comparableProducts;
		let updatedProducts = comparableProducts;
		comparableProducts = currState.map((prod) => {
			let tempProd = prod;
			updatedProducts.forEach((updatedP) => {
				if (updatedP.id == prod.id) {
					tempProd.isSelected = updatedP.isSelected;
				}
			});
			return tempProd;
		});
		this.setState({
			compTableActive,
			comparableProducts,
		});
	}

	render() {
		let tabularData = this.state.tabularData;
		let hasComparisonData = tabularData !== 'no_data_back';
		return ReactDOM.createPortal(
			<React.Fragment>
				{hasComparisonData && (
					<CompareTable
						comparisonTableId={this.tableUpdate.comparisonTableId}
						compTableActive={this.state.compTableActive}
						comparableProducts={this.state.comparableProducts}
						handleComparisonSelection={this.handleComparisonSelection}
						tabularData={this.state.tabularData}
						handleCancelComparions={this.handleCancelComparions}
					/>
				)}
			</React.Fragment>,
			this.dynamicTableRoot
		);
	}
}

const ProductPricingComparisonTableConfig = {
  emptyLabel: 'Product Pricing Comparison Table Section',
  isEmpty: (props) => !props.tableProps,
};

class ProductPricingComparisonTableBase extends Component {
	constructor(props) {
		super(props);
		this.initSecContext = initSecContext.getPropsContext();
		this.isLastSection = this.initSecContext.isLast;
	}

	render() {
		if (!this.isLastSection) {
			return null;
		}
		let tabProps = this.props.tableProps ? this.props.tableProps : this.props;
		return <ProductPricingComparisonTableImpl fromDialog={tabProps} />;
	}
}

const ProductPricingComparisonTable = (props) => {
  return (
    <EditableComponent config={ProductPricingComparisonTableConfig} {...props}>
      <ProductPricingComparisonTableBase {...props} />
    </EditableComponent>
  );
};
MapTo(AEM_MAPPED_TYPES.PRODUCT_PRICING_COMPARISON_TABLE)(ProductPricingComparisonTable);
export default ProductPricingComparisonTable;
